import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { ExperienceCreationRequest, ExperienceData, ExperienceEditRequest, ExperienceSearchFilter } from "../../models/experience.model";

export const experienceCreationRequest = createAction(
        '[Experience] Experience creation request', props<{ experienceCreationRequest: ExperienceCreationRequest }>());

export const experienceCreationSuccess = createAction(
        '[Experience] Experience creation success', props<{ createdExperience : ExperienceData }>());

export const experienceCreationFail = createAction(
        '[Experience] Experience creation fail',props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const experienceEdit = createAction(
        '[Experience] Experience edit', props<{ experienceToEdit: ExperienceData }>());

export const experienceCopy = createAction(
        '[Experience] Experience copy', props<{ experienceToCopy: ExperienceData }>());

export const experienceEditSave = createAction(
        '[Experience] Experience edit save', props<{ experienceToEdit: ExperienceEditRequest }>());

export const experienceEditSaveSuccess = createAction(
        '[Experience] Experience edit save success', props<{ editedExperience: ExperienceData }>());

export const experienceEditSaveFail = createAction(
        '[Experience] Experience edit fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const experienceView = createAction(
        '[Experience] Experience view', props<{ experienceToView: ExperienceData }>());
        
export const experienceSearchRequest = createAction(
        '[Experience] Experience search request', props<{ searchFilter: ExperienceSearchFilter }>());

export const experienceSearchAllRequest = createAction(
        '[Experience] Experience search all request');

export const experienceSearchSuccess = createAction(
        '[Experience] Experience search success', props<{ searchResult: ExperienceData[] }>());

export const experienceSearchDataReset = createAction(
        '[Experience] Experience search data reset');

export const experienceSearchFail = createAction(
        '[Experience] Experience search fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());

export const experienceDeleteRequest = createAction(
        '[Experience] Experience delete request', props<{ experienceId: number }>());

export const experienceDeleteSuccess = createAction(
        '[Experience] Experience delete success', props<{ experienceId: number }>());

export const experienceDeleteFail = createAction(
        '[Experience] Experience delete fail', props<{ httpErrorData: HttpErrorResponse, translatedHeaderMessage: string }>());